import img10 from '../.././Image/img10.PNG'
import img7 from '../.././Image/img7.PNG'
import img4 from '../.././Image/img4.PNG'

function Cloud() {
    return (

        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">
                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img7}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img10}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img4}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                </div>

            </div>

           <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

              <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Infrastructure Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A document outlining the complete cloud setup — servers, storage, networking,
                            environments, resource allocation, and scalability architecture.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Configuration Guidelines
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Formal rules for configuring cloud services — instances, databases, VPCs,
                            load balancers, IAM roles, and environment settings across all platforms.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Deployment Framework
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Detailed instructions for deploying applications — CI/CD pipelines,
                            containerization, orchestration, environment promotion, and automated standards.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 
                         w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Operations & Monitoring Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Defines operational practices — monitoring, alerting, health checks,
                            backups, resource optimization, and cloud maintenance workflows.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 
                         w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Security Standards Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A complete guide for securing cloud environments — IAM rules, encryption,
                            network protection, compliance, and threat prevention models.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 
                         w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Architecture Handbook
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            An overview of cloud design — multi-tier architecture, microservices,
                            API gateways, storage layers, and distributed system patterns.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 
                         w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Services Component Library
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A reusable collection of cloud components — compute instances, buckets,
                            functions, queues, databases, CDN, and reusable modules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Governance Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Explains cloud policies — cost rules, usage monitoring, access control,
                            provisioning guidelines, and lifecycle management.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 
                         w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Platform & DevOps System
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A combined manual merging cloud workflows with DevOps practices — CI/CD,
                            IaC, pipelines, automation, and consistent environments.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 
                         w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Cloud Strategy Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A strategic document focusing on cloud adoption — migration plans,
                            scaling strategy, cost optimization, reliability, and long-term roadmap.
                        </p>
                    </div>



                </div>

            </div>
        </>
    );
}



export default Cloud;